/**
 * `effectiveStatus` — the ONE derivation of a batch process's *displayed* status
 * (TV1-2294 ticket 48).
 *
 * WHY IT EXISTS AS A MODULE. The readmodel sometimes keeps `status: 'running'`
 * after a run has actually finished (the completion event lands before the status
 * flip projects), so every card has to re-derive the status it shows. That rule
 * lived inline in `BatchProcessCard`; the phone card needs the identical rule,
 * and two copies of a status derivation is precisely how a desktop row and a
 * mobile row end up disagreeing about whether a process is still running — which
 * would mean disagreeing about whether "Cancelar" or "Archivar" is offered.
 *
 * It is a PURE function of the row: no CDSE state, command, handler, invariant or
 * policy (this PR forbids new ones), and no hook, so it is callable from a
 * node-mode test.
 *
 * The logic is `BatchProcessCard`'s, moved verbatim.
 */

import type { BatchProcessesReadmodelType } from '@bett3r-dev/teselly-domain';
import type { BatchProcessStatus } from '../../../constants';

export const effectiveStatus = (
  process: BatchProcessesReadmodelType
): BatchProcessStatus => {
  const errorCount = process.erroredTargetIds?.length ?? 0;

  return (
    process.status === 'running' &&
    process.totalItems > 0 &&
    process.completedCount >= process.totalItems
  )
    ? ( errorCount > 0 ? 'errored' : 'completed' )
    : ( process.status as BatchProcessStatus );
};

export default effectiveStatus;
